import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { flowRight as compose } from 'lodash';
import { Col } from 'react-bootstrap';
import withStyles from 'isomorphic-style-loader/withStyles';

// Component
import Reviews from '../../components/Reviews';
import ReviewsByYou from '../../components/Reviews/ReviewsByYou';

// Graphql
import UserReviewsQuery from './UserReviews.graphql';
import PendingReviewsQuery from './PendingReviews.graphql';
import { withQuery } from '../../hoc/withGraphql';

import cs from '../../components/commonStyle.css';
import s from './ReviewsContainer.css';

const ReviewsContainer = (props) => {

  const [load, setLoad] = useState(true);
  const [isLoading, setIsLoading] = useState(false);

  const loadMore = (ownerType, current, searchKey) => {
    const { userReviewsData: { userReviews, fetchMore } } = props;
    setIsLoading(true)
    fetchMore({
      query: UserReviewsQuery,
      variables: {
        ownerType,
        offset: userReviews?.results?.length,
        loadCount: 3,
        current,
        searchKey
      },
      updateQuery: (previousResult, { fetchMoreResult }) => {
        if (!fetchMoreResult) {
          return {
            userReviews: {
              totalCount: previousResult?.userReviews?.totalCount,
              results: previousResult?.userReviews?.results,
              count: previousResult?.userReviews?.count
            }
          }
        }
        return {
          userReviews: {
            totalCount: fetchMoreResult?.userReviews?.totalCount,
            count: fetchMoreResult?.userReviews?.count,
            results: [...previousResult?.userReviews?.results, ...fetchMoreResult?.userReviews?.results],
          }
        };
      },
    }).then(() => {
      setIsLoading(false)
    });
  }

  const { userReviewsData, pendingReviewsData, type } = props;

  return (
    <>
      <Col xs={12} sm={12} md={8} lg={8} className={cs.spaceTop6}>

        {load && type == 'about-you' && <Reviews
          reviewsData={userReviewsData}
          loadMore={loadMore}
          isLoading={isLoading}
        />}
        {
          load && type == 'you' && <ReviewsByYou
            reviewsData={userReviewsData}
            pendingData={pendingReviewsData}
            loadMore={loadMore}
            isLoading={isLoading}
          />
        }
      </Col>
    </>
  );
}


ReviewsContainer.propTypes = {
  userReviewsData: PropTypes.shape({
    loading: PropTypes.bool,
    userReviews: PropTypes.array
  }),
  pendingReviewsData: PropTypes.shape({
    loading: PropTypes.bool,
    pendingReviews: PropTypes.array
  })
};

export default compose(
  withStyles(cs, s),
  withQuery(UserReviewsQuery,
    {
      name: 'userReviewsData',
      options: (props) => ({
        variables: {
          ownerType: props?.type == 'you' ? 'me' : 'others',
          current: 'responded'
        },
        fetchPolicy: 'network-only',
        ssr: false
      })
    }
  ),
  withQuery(PendingReviewsQuery,
    {
      name: 'pendingReviewsData',
      options: (props) => ({
        fetchPolicy: 'network-only',
        ssr: false
      })
    }
  ),
)(ReviewsContainer);